/**
 * Given a min and max, restrict the given number to be within the min and max.
 */
export const clamp = (min: number, max: number, value: number) =>
  Math.min(max, Math.max(min, value));
